/** Tenant slug kuralları (bağımsız modül; döngüsel import yok). */
import { z } from 'zod';
/** Tenant slug: küçük harf, rakam ve tire; 3–40 karakter; tire ile başlayıp bitemez. */
export const TENANT_SLUG_REGEX = /^[a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])$/;
export const tenantSlugSchema = z
    .string()
    .min(3)
    .max(40)
    .regex(TENANT_SLUG_REGEX, 'Slug yalnız küçük harf, rakam ve tire içerebilir');
/** Kullanıcı girdisini slug kuralına normalize eder (Türkçe karakterler ASCII'ye çevrilir). */
export function normalizeSlug(input) {
    const map = {
        ç: 'c',
        ğ: 'g',
        ı: 'i',
        ö: 'o',
        ş: 's',
        ü: 'u',
        â: 'a',
        î: 'i',
        û: 'u',
    };
    return input
        .trim()
        .toLocaleLowerCase('tr-TR')
        .replace(/i̇/g, 'i')
        .replace(/[çğıöşüâîû]/g, (ch) => map[ch] ?? ch)
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40)
        .replace(/-+$/g, '');
}
//# sourceMappingURL=slug.js.map